import { GroupOverlap } from '@pubstack/common/src/refresh'
import { Site } from '@pubstack/common/src/site'
import { sortByName } from '@pubstack/common/src/sort'
import { FunctionComponent, useMemo, useState } from 'react'
import { toggleValueInArray } from '~/utils/array'
import { RefreshGroupComboSearch } from './RefreshGroupComboSearch'

export const RefreshGroupSitesForm: FunctionComponent<{
  siteList: Pick<Site, 'id' | 'name'>[]
  refreshGroupSites: Pick<Site, 'id' | 'name'>[]
  overlap: GroupOverlap
  updateRefreshGroup: (sites: Pick<Site, 'id' | 'name'>[]) => unknown
}> = ({ siteList, refreshGroupSites, updateRefreshGroup, overlap }) => {
  const [siteFilter, setSiteFilter] = useState('')

  const sortedSites = useMemo(() => sortByName(siteList), [siteList])

  // building checkboxes: we check sites that are in refresh group's ones, then filter them according to the search value
  const options = sortedSites
    .map((s) => ({ label: s.name, value: s.id, checked: refreshGroupSites.some((rs) => rs.id === s.id) }))
    .filter((s) => s.label.toLowerCase().includes(siteFilter.toLowerCase()))

  const onToggle = (site: Pick<Site, 'id' | 'name'>) => {
    // toggling the site
    const newSites = toggleValueInArray(refreshGroupSites, site, 'id')

    // dispatch the new value
    updateRefreshGroup(newSites)
  }

  const onSelectAll = () => {
    if (options.every((o) => o.checked)) {
      updateRefreshGroup(refreshGroupSites.filter((s) => !options.find((o) => o.value === s.id)))
    } else {
      updateRefreshGroup([...refreshGroupSites, ...siteList.filter((s) => s.name.toLowerCase().includes(siteFilter.toLowerCase()) && !refreshGroupSites.find((rs) => rs.id === s.id))])
    }
  }

  return (
    <RefreshGroupComboSearch
      overlapIds={overlap.tagIds}
      onAllCheckboxToggle={onSelectAll}
      onCheckboxToggle={(index) => onToggle({ name: options[index].label, id: options[index].value })}
      options={options}
      onSearch={setSiteFilter}
    />
  )
}
